import { render, staticRenderFns } from "./scanInputContact.vue?vue&type=template&id=1f8ec41c&scoped=true&"
import script from "./scanInputContact.vue?vue&type=script&lang=js&"
export * from "./scanInputContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ec41c",
  null
  
)

export default component.exports